/**
 * Blog SEO / URL contract (permanent)
 *
 * Path shape never changes: `/blog/{slug}`
 * Canonical host (lasting): https://trytrivia.co
 *
 * Current temporary host may be app.trytrivia.co. When the hub moves to
 * trytrivia.co (or any lasting host), 301 EACH slug 1:1:
 *   https://app.trytrivia.co/blog/{slug}  →  https://trytrivia.co/blog/{slug}
 * Also 301 the hub: /blog → lasting /blog
 * Then refresh sitemap + Search Console on the lasting host.
 *
 * Do not rename slugs after publish. That breaks SEO.
 */
export const BLOG_CANONICAL_ORIGIN = 'https://trytrivia.co';

export const blogCanonicalUrl = (slug) =>
  slug ? `${BLOG_CANONICAL_ORIGIN}/blog/${slug}` : `${BLOG_CANONICAL_ORIGIN}/blog`;

/** Slugs that must receive a 301 when leaving app.trytrivia.co */
export const BLOG_PERMANENT_SLUGS = [
  'stop-zoom-happy-hour-bond-in-slack-teams',
  'nobody-owns-the-birthday',
  'forced-fun-vs-five-minute-quiz-habit',
  'icebreakers-hostage-situation-slack-teams',
  'new-hire-scavenger-hunt-tools-not-people',
  'optional-events-nobody-opts-in',
  'slack-channel-died-after-kickoff',
  'proximity-bias-hybrid-belonging'
];
